/**
 * Actions dans les bandeaux hero (AdminPageHero, dashboard, empty states alignés).
 * Par défaut : style neutre ; vert uniquement quand l’action est « sélectionnée »
 * (modale ouverte, ou lien NavLink actif). Feedback tactile : pseudo-classes active:* sur l’état neutre.
 */

export const ADMIN_HERO_ACTION_IDLE =
  "inline-flex items-center justify-center gap-2 rounded-xl border border-slate-700 bg-slate-900/80 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-slate-800";

/** Au clic (sans état sélectionné persistant) — même principe que le dashboard. */
export const ADMIN_HERO_ACTION_ACTIVE_PSEUDO =
  " active:bg-emerald-500 active:text-slate-950 active:shadow-lg active:shadow-emerald-500/20 active:ring-2 active:ring-emerald-400/40";

export const ADMIN_HERO_ACTION_SELECTED =
  "inline-flex items-center justify-center gap-2 rounded-xl border border-transparent bg-emerald-500 px-4 py-2.5 text-sm font-semibold text-slate-950 shadow-lg shadow-emerald-500/20 ring-2 ring-emerald-400/40 transition-colors hover:bg-emerald-400";

export function adminHeroActionClassName(selected: boolean): string {
  return selected
    ? ADMIN_HERO_ACTION_SELECTED
    : `${ADMIN_HERO_ACTION_IDLE}${ADMIN_HERO_ACTION_ACTIVE_PSEUDO}`;
}
